export const GET_DEPARTAMENTOS = 'GET_DEPARTAMENTO'
export const GET_OPERADORES = 'GET_OPERADOR'
export const GET_FILAS = 'GET_FILA'
export const GET_PAUSAS = 'GET_PAUSA'